import { createContext } from "react";
import type { Service } from "@/types/Service";

export const ServiceContext = createContext<Service | null>(null);
